// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fff35255","455":"a4044645","977":"a2858a45"}[chunkId] + ".chunk.js";
};